/**
 * Instant, typo-tolerant search over the Help Centre index the server built for
 * this user (only articles their role can see are in it).
 */
import MiniSearch from 'minisearch'

export function buildHelpSearch(articles) {
  const search = new MiniSearch({
    idField: 'slug',
    fields: ['title', 'summary', 'keywords', 'headings', 'text'],
    storeFields: ['slug', 'title', 'summary', 'section_title', 'type_label'],
    extractField: (doc, field) => {
      const value = doc[field]
      return Array.isArray(value) ? value.join(' ') : value
    },
    searchOptions: {
      boost: { title: 4, keywords: 3, headings: 2, summary: 2 },
      prefix: true,
      fuzzy: 0.2,
      combineWith: 'AND',
    },
  })
  search.addAll(articles || [])
  return search
}

export function searchHelp(search, query, limit = 8) {
  const text = String(query || '').trim()
  if (!search || text.length < 2) return []
  let results = search.search(text)
  // Nothing matched every word: fall back to any word so people still get suggestions.
  if (!results.length) results = search.search(text, { combineWith: 'OR' })
  return results.slice(0, limit)
}
